/* istanbul ignore file */
import './ErrorFallback.css';

/**
 * Full-page fallback rendered by Sentry.ErrorBoundary when a render crash would
 * otherwise blank the screen. Presentational only — the error is already
 * reported by the boundary.
 */
const ErrorFallback = () => (
  <div className='error-fallback' role='alert'>
    <div className='error-fallback__card'>
      <h1 className='error-fallback__title'>Something went wrong</h1>
      <p className='error-fallback__text'>
        The error has been reported to our team. Try reloading the page.
      </p>
      <button
        type='button'
        className='error-fallback__button'
        onClick={() => window.location.reload()}
      >
        Reload
      </button>
    </div>
  </div>
);

export default ErrorFallback;
